class Rebates {
    totalCurrentMonthAmount;
    totalAmount;
    totalInvestedAmount;
    rebatesIncomes;
    bricksSummary;
    constructor(data) {
        this.totalCurrentMonthAmount = data.totalCurrentMonthAmount;
        this.totalAmount = data.totalAmount;
        this.totalInvestedAmount = data.totalInvestedAmount;
        this.rebatesIncomes = data.rebatesIncomes;
        this.bricksSummary = data.bricksSummary;
    }
}
export default Rebates;
